/* src/app/core/tabs/tab/tab.component.scss */
.pane {
  padding: 0em;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  min-width: 350px;
  height: 100vh;
  background: #fff;
}
/*# sourceMappingURL=tab.component.css.map */
